var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 18.3332C12.1667 18.3332 12.8744 18.2321 15.8033 15.3031C18.7322 12.3742 18.7322 7.62547 15.8033 4.69654C14.7656 3.65881 13.4994 2.98875 12.1667 2.68636M12.1667 18.3332H17.1667M12.1667 18.3332L12.1667 13.3332M8.83333 1.66667C8.83333 1.66667 8.12563 1.76777 5.1967 4.6967C2.26777 7.62563 2.26777 12.3744 5.1967 15.3033C6.23443 16.341 7.5006 17.0111 8.83333 17.3135M8.83333 1.66667L3.83333 1.6665M8.83333 1.66667L8.83333 6.6665",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.4277eafa1df9868cf2899216f4b829a2.svg";
export { ForwardRef as ReactComponent };